import { render, staticRenderFns } from "./GridInvoiceLink.vue?vue&type=template&id=3a70960d&"
import script from "./GridInvoiceLink.vue?vue&type=script&lang=js&"
export * from "./GridInvoiceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports